module.exports = __webpack_public_path__ + "img/250.c7dd32ef.gif";